/* eslint-disable indent */

import adCostPreset from '../metrics/adCost'
import balancePreset from '../metrics/balance'
import clicksPreset from '../metrics/clicks'
import conversionsPreset from '../metrics/conversions'
import impressionsPreset from '../metrics/impressions'
import impressionsDiffPreset from '../metrics/impressionsDiff'
import incomePreset from '../metrics/income'
import newToBrandCustomersPreset from '../metrics/newToBrandCustomers'
import newToBrandRevenuePreset from '../metrics/newToBrandRevenue'
import roasPreset from '../metrics/roas'
import totalCampaignsPreset from '../metrics/totalCampaigns'
import totalSpentPreset from '../metrics/totalSpent'
import totalSpentNoScalePreset from '../metrics/totalSpentNoScale'
import viewsPreset from '../metrics/views'
import { ChartPreset, CreateChartOptions, CreateDatasets } from '../types'

const availablePresets = {
  impressions: impressionsPreset,
  clicks: clicksPreset,
  conversions: conversionsPreset,
  views: viewsPreset,
  income: incomePreset,
  totalSpent: totalSpentPreset,
  totalSpentNoScale: totalSpentNoScalePreset,
  balance: balancePreset,
  roas: roasPreset,
  totalCampaigns: totalCampaignsPreset,
  adCost: adCostPreset,
  impressionsDiff: impressionsDiffPreset,
  newToBrandCustomers: newToBrandCustomersPreset,
  newToBrandRevenue: newToBrandRevenuePreset,
  'impressions-compare': impressionsPreset,
  'clicks-compare': clicksPreset,
  'conversions-compare': conversionsPreset,
  'views-compare': viewsPreset,
  'income-compare': incomePreset,
  'totalSpent-compare': totalSpentPreset,
  'totalSpentNoScale-compare': totalSpentNoScalePreset,
  'balance-compare': balancePreset,
  'roas-compare': roasPreset,
  'totalCampaigns-compare': totalCampaignsPreset,
  'adCost-compare': adCostPreset,
  'impressionsDiff-compare': impressionsDiffPreset,
  'newToBrandCustomers-compare': newToBrandCustomersPreset,
  'newToBrandRevenue-compare': newToBrandRevenuePreset
}

const datasets: CreateDatasets = ({
  data,
  metrics,
  compareData,
  isCompare
}) => {
  const response = metrics.map(metric =>
    availablePresets[metric].dataset({ data, selectedMetrics: metrics })
  )

  const responseCompare = isCompare
    ? metrics.map(metric =>
        availablePresets[metric].dataset({
          data: compareData,
          selectedMetrics: metrics,
          isCompare
        })
      )
    : []

  return [...response, ...responseCompare]
}

const chartOptions: CreateChartOptions = ({ data, metrics, compareData }) => {
  const response = {
    scales: metrics.reduce(
      (acc, metric, index) => ({
        ...acc,
        ...availablePresets[metric].optionsScale({
          data,
          selectedMetrics: metrics,
          drawOnChartArea: index === 0,
          showScaleRuler: index < 2,
          position: index === 0 ? 'left' : 'right'
        })
      }),
      {}
    )
  }

  const responseCompare = {
    scales: metrics.reduce(
      (acc, metric, index) => ({
        ...acc,
        ...availablePresets[metric].optionsScale({
          data: compareData,
          isCompare: true,
          selectedMetrics: metrics,
          drawOnChartArea: index === 0,
          showScaleRuler: false,
          position: index === 0 ? 'left' : 'right'
        })
      }),
      {}
    )
  }

  return { scales: { ...response.scales, ...responseCompare.scales } }
}

export const dynamicChartPreset: ChartPreset = ({
  data,
  metrics = ['clicks', 'impressions'],
  compareData = null,
  isCompare = false
}) => ({
  datasets: datasets({ data, metrics, compareData, isCompare }),
  chartOptions: chartOptions({ data, metrics })
})
